import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import type { CollectionOfferGroup } from "@anaconda/core/nft-collection/collection/types"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import {
  type InfiniteData,
  useSuspenseInfiniteQuery,
} from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import { CollectionOfferGroupsMoleculeReatom } from "../store.reatom"

interface OfferGroupsPage {
  offerGroups: CollectionOfferGroup[]
  bestTotalVolume: string
  cursor?: string
}

export const useCollectionOfferItemsReatom = () => {
  const { offersQueryParams } = useMolecule(CollectionOfferGroupsMoleculeReatom)
  const queryParams = offersQueryParams()
  const offersQuery = useSuspenseInfiniteQuery<
    OfferGroupsPage,
    Error,
    InfiniteData<OfferGroupsPage>,
    readonly ["collection", "offer-groups", CollectionId],
    string | undefined
  >(queryParams)

  const queryResult = useMemo(
    () => ({
      ...offersQuery,
      pages: offersQuery.data.pages.map((page: OfferGroupsPage) => ({
        items: page.offerGroups.map((offerGroup: CollectionOfferGroup) => ({
          offerGroup,
          bestTotalVolume: page.bestTotalVolume,
        })),
      })),
    }),
    [offersQuery],
  )

  return useInfiniteTableItems(queryResult)
}
